import React from "react";
import {
  Card, Row, Col, Container
} from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Mousewheel } from "swiper";
import {
  topArticles, articleSlider, articleContent, acTitle,
  acSubtitle, articleCard, articleImg, articleCardBody,
  articleCardContent, articleCardTitle, articleCardLink,
  articleContentFirst
} from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";
import ArrowRight from "assets/svgs/arrow-right.svg";
import Link from "components/link";

const TopArticles = ({ data }) => {  
  const { title, subtitle, article } = data ;

  const d = data.article;
  const articleImage = d.articleImage;

  var settings = {
    slidesPerView: 1.3,
    speed: 500,
    spaceBetween: 25,
    pagination: { clickable: true },
    modules: [Pagination, Mousewheel],
    navigation: { clickable: true },
    breakpoints: {
      767: {
        spaceBetween: 25,
        slidesPerView: 3,
      }
    },
  };

  return (
    <div className={`${topArticles}`} style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
      <Container>
        <div className={articleContentFirst}>
          <h6 className={acTitle}>{title}</h6>
          <h2 className={acSubtitle}>{subtitle}</h2>
        </div>
        <Row>
          <Swiper {...settings} className={articleSlider}>
            {article.map((d, index) => {
              return(
                (index == 1 ?   <SwiperSlide key={index}> <Col >
                  <div className={articleContent}>
                    <h6 className={acTitle}>{title}</h6>
                    <h2 className={acSubtitle}>{subtitle}</h2>
                  </div>
                  <Link to={d.articleLink}>
                    <Card className={articleCard}>
                      <Card.Img className={articleImg} srcSet={getImagePath(d?.articleImage, true)} alt={d.articleImage?.alt}/>
                      <Card.Body className={articleCardBody}>
                        <div className={articleCardContent}>
                          <Card.Title className={articleCardTitle}><h3>{d.articleTitle}</h3>
                            <span className={articleCardLink} href={d.articleLink}>
                              <ArrowRight/>
                            </span>
                          </Card.Title>
                        </div>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col></SwiperSlide>  : <SwiperSlide key={index}><Col>
                  <Link to={d.articleLink} >
                    <Card className={articleCard}>
                      <Card.Img className={articleImg}  srcSet={getImagePath(d?.articleImage, true)} alt={articleImage?.alt} />
                      <Card.Body className={articleCardBody}>
                        <div className={articleCardContent}>
                          <Card.Title className={articleCardTitle}><h3>{d.articleTitle}</h3>
                            <span className={articleCardLink} href={d.articleLink}>
                              <ArrowRight/>
                            </span>
                          </Card.Title>
                        </div>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col></SwiperSlide>  )
              );
            })}
          </Swiper>
        </Row>
      </Container>
    </div>
  );
};

export default TopArticles;
